module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/heart-8a5f2ca6ae59461fcd4ceee3a3c14c37.svg";